/**
 * @generated SignedSource<<a236607038479338bf03b72e84171861>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type connectorByIdQuery$variables = {
  name: string;
  owner?: string | null;
};
export type connectorByIdQuery$data = {
  readonly connector: {
    readonly devStatusObject: {
      readonly endDatetime: any | null;
      readonly isRunning: boolean;
      readonly runningDatetime: any | null;
      readonly startDatetime: any | null;
      readonly status: string | null;
    } | null;
    readonly displayName: string | null;
    readonly models: ReadonlyArray<{
      readonly createdAt: any;
      readonly destinationStatuses: ReadonlyArray<{
        readonly destinationName: string | null;
        readonly statusObject: {
          readonly isRunning: boolean;
          readonly status: string | null;
        } | null;
      } | null> | null;
      readonly destinations: ReadonlyArray<{
        readonly displayName: string | null;
        readonly name: string;
        readonly provider: string;
      }>;
      readonly devDestinationStatuses: ReadonlyArray<{
        readonly destinationName: string | null;
        readonly statusObject: {
          readonly isRunning: boolean;
          readonly status: string | null;
        } | null;
      } | null> | null;
      readonly devStatusObject: {
        readonly endDatetime: any | null;
        readonly isRunning: boolean;
        readonly runningDatetime: any | null;
        readonly startDatetime: any | null;
        readonly status: string | null;
      } | null;
      readonly displayName: string | null;
      readonly egressedTables: ReadonlyArray<{
        readonly revisionNumber: number;
        readonly tables: ReadonlyArray<string | null> | null;
      }>;
      readonly name: string;
      readonly preconfiguredModelRef: string | null;
      readonly provider: string | null;
      readonly publishedRevisions: ReadonlyArray<{
        readonly revisionNumber: number;
      }>;
      readonly publishedTables: ReadonlyArray<string>;
      readonly publishedTablesObject: ReadonlyArray<{
        readonly name: string;
        readonly schema: string | null;
      }>;
      readonly qcDestinationStatuses: ReadonlyArray<{
        readonly destinationName: string | null;
        readonly statusObject: {
          readonly isRunning: boolean;
          readonly status: string | null;
        } | null;
      } | null> | null;
      readonly qcStatusObject: {
        readonly endDatetime: any | null;
        readonly isRunning: boolean;
        readonly runningDatetime: any | null;
        readonly startDatetime: any | null;
        readonly status: string | null;
      } | null;
      readonly statusObject: {
        readonly endDatetime: any | null;
        readonly isRunning: boolean;
        readonly runningDatetime: any | null;
        readonly startDatetime: any | null;
        readonly status: string | null;
      } | null;
    }>;
    readonly name: string;
    readonly qcStatusObject: {
      readonly endDatetime: any | null;
      readonly isRunning: boolean;
      readonly runningDatetime: any | null;
      readonly startDatetime: any | null;
      readonly status: string | null;
    } | null;
    readonly sources: ReadonlyArray<{
      readonly createdAt: any;
      readonly displayName: string | null;
      readonly ingestRevisions: ReadonlyArray<{
        readonly semanticVersion: string;
      }>;
      readonly name: string;
      readonly provider: string | null;
      readonly schedule: string;
      readonly statusObject: {
        readonly endDatetime: any | null;
        readonly isRunning: boolean;
        readonly runningDatetime: any | null;
        readonly startDatetime: any | null;
        readonly status: string | null;
      } | null;
    }>;
    readonly statusObject: {
      readonly endDatetime: any | null;
      readonly isRunning: boolean;
      readonly runningDatetime: any | null;
      readonly startDatetime: any | null;
      readonly status: string | null;
    } | null;
  };
};
export type connectorByIdQuery = {
  response: connectorByIdQuery$data;
  variables: connectorByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRunning",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "runningDatetime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDatetime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDatetime",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusObject",
  "kind": "LinkedField",
  "name": "statusObject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusObject",
  "kind": "LinkedField",
  "name": "devStatusObject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusObject",
  "kind": "LinkedField",
  "name": "qcStatusObject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revisionNumber",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "destinationName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusObject",
    "kind": "LinkedField",
    "name": "statusObject",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  }
],
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "Connector",
    "kind": "LinkedField",
    "name": "connector",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "sources",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v2/*: any*/),
          (v1/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IngestRevision",
            "kind": "LinkedField",
            "name": "ingestRevisions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "semanticVersion",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "models",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v2/*: any*/),
          (v1/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedTables",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preconfiguredModelRef",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EgressedTablesObject",
            "kind": "LinkedField",
            "name": "egressedTables",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tables",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DestinationStatusObject",
            "kind": "LinkedField",
            "name": "destinationStatuses",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublishedRevisionObject",
            "kind": "LinkedField",
            "name": "publishedRevisions",
            "plural": true,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublishedTablesObject",
            "kind": "LinkedField",
            "name": "publishedTablesObject",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schema",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Destination",
            "kind": "LinkedField",
            "name": "destinations",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v2/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DestinationStatusObject",
            "kind": "LinkedField",
            "name": "devDestinationStatuses",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DestinationStatusObject",
            "kind": "LinkedField",
            "name": "qcDestinationStatuses",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "connectorByIdQuery",
    "selections": (v13/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "connectorByIdQuery",
    "selections": (v13/*: any*/)
  },
  "params": {
    "cacheID": "36622d107a73d28d228e65ddb6546ab9",
    "id": null,
    "metadata": {},
    "name": "connectorByIdQuery",
    "operationKind": "query",
    "text": "query connectorByIdQuery(\n  $name: String!\n  $owner: String\n) {\n  connector(name: $name, owner: $owner) {\n    displayName\n    name\n    statusObject {\n      status\n      isRunning\n      runningDatetime\n      endDatetime\n      startDatetime\n    }\n    devStatusObject {\n      status\n      isRunning\n      runningDatetime\n      endDatetime\n      startDatetime\n    }\n    qcStatusObject {\n      status\n      isRunning\n      runningDatetime\n      endDatetime\n      startDatetime\n    }\n    sources {\n      provider\n      name\n      displayName\n      createdAt\n      schedule\n      ingestRevisions {\n        semanticVersion\n      }\n      statusObject {\n        status\n        isRunning\n        runningDatetime\n        endDatetime\n        startDatetime\n      }\n    }\n    models {\n      provider\n      name\n      displayName\n      createdAt\n      publishedTables\n      preconfiguredModelRef\n      egressedTables {\n        revisionNumber\n        tables\n      }\n      destinationStatuses {\n        destinationName\n        statusObject {\n          status\n          isRunning\n        }\n      }\n      publishedRevisions {\n        revisionNumber\n      }\n      publishedTablesObject {\n        name\n        schema\n      }\n      destinations {\n        provider\n        name\n        displayName\n      }\n      statusObject {\n        status\n        isRunning\n        runningDatetime\n        endDatetime\n        startDatetime\n      }\n      devStatusObject {\n        status\n        isRunning\n        runningDatetime\n        endDatetime\n        startDatetime\n      }\n      qcStatusObject {\n        status\n        isRunning\n        runningDatetime\n        endDatetime\n        startDatetime\n      }\n      devDestinationStatuses {\n        destinationName\n        statusObject {\n          status\n          isRunning\n        }\n      }\n      qcDestinationStatuses {\n        destinationName\n        statusObject {\n          status\n          isRunning\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08aec2135abc7ff3e6e2665084b3f449";

export default node;
